import CloseIcon from '@mui/icons-material/Close'
import { styled } from '@mui/material'
import React, { useCallback } from 'react'

import { ButtonAlternative, ButtonSecondary } from '../../../Button'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '../../../Dialog'
import { FlexLayout } from '../../../Layout'
import { Typography } from '../../../Typography'
import { CatalogLabels } from '../definitions'
import { useCatalog } from '../hooks/useCatalog'

const DialogTitleLayout = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const CloseButton = styled('div')`
  cursor: pointer;
`

const DialogBody = styled(DialogContent)`
  padding: 20px 20px 0;
  max-width: 500px;
`

type Props = {
  catalog: ReturnType<typeof useCatalog>
  labels: Pick<CatalogLabels, 'topic'>
}

export const DeleteDialog = (props: Props) => {
  const { catalog, labels } = props

  const confirm = useCallback(() => {
    const success = catalog.removeItemById(catalog.deleteDialogState.itemId || '')
    if (success) {
      catalog.openAlert('Item deleted successfully')
    }
    close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const close = useCallback(() => catalog.closeDeleteDialog(), [])

  return (
    <Dialog data-test-id="-catalog-delete-dialog-container" open={catalog.deleteDialogState.open} onClose={close}>
      <DialogTitle>
        <DialogTitleLayout>
          <Typography itemType="h3">{`Delete ${labels.topic}`}</Typography>
          <CloseButton data-test-id="catalog-close-delete-dialog" onClick={close}>
            <CloseIcon />
          </CloseButton>
        </DialogTitleLayout>
      </DialogTitle>
      <DialogBody>
        <FlexLayout>
          <p>Are you sure?</p>
          <p>This action cannot be reversed.</p>
        </FlexLayout>
      </DialogBody>
      <DialogActions>
        <ButtonSecondary data-test-id="catalog-delete-dialog-cancel-button" onClick={close}>
          Cancel
        </ButtonSecondary>
        <ButtonAlternative data-test-id="catalog-delete-dialog-confirm-button" onClick={confirm}>
          Delete
        </ButtonAlternative>
      </DialogActions>
    </Dialog>
  )
}
